/**
 * @file: ReportScreens.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ConstructionReportScreen } from '@euler/app/flows/report/pages/ConstructionReport';
import { DeliveryCheckReportScreen } from '@euler/app/flows/report/pages/DeliveryCheckReport';
import { InspectionReportScreen } from '@euler/app/flows/report/pages/InspectionReport';
import { PreInspectionReportScreen } from '@euler/app/flows/report/pages/PreInspectionReport';
import { SamplingCheckReportScreen } from '@euler/app/flows/report/pages/SamplingCheckReport';
import { ScreenToParams } from '@euler/functions/spreadScreens';

export const ReportScreens = {
  preInspectionReport: PreInspectionReportScreen,
  inspectionReport: InspectionReportScreen,
  constructionReport: ConstructionReportScreen,
  deliveryCheckReport: DeliveryCheckReportScreen,
  samplingCheckReport: SamplingCheckReportScreen,
};

export type ReportNavParams = ScreenToParams<typeof ReportScreens>;
